import React, { createContext } from 'react';
// ---- IMPORT DATA ---------------------------------------- //
import data from '../data.json';
export const GeneralContext = createContext(null);

export const GeneralProvider = (props) => {
  const information = data;

  return (
    <GeneralContext.Provider value={[information]}>
      {props.children}
    </GeneralContext.Provider>
  );
};